<template>
    <div class="un-start">
        <img :src="emptyImg"/>
        <div class="text">投票稍后就来，感谢耐心等待</div>
    </div>
</template>
<script>
import emptyImg from '../../../../images/vote-un-start.png'
export default {
    props: ['articleData'],
    data() {
        return {
            emptyImg
        }
    },
}
</script>
<style lang="less" scoped>
    .un-start {
        width: 100%;
        height: 130px;
        box-sizing: border-box;
        padding: 20px 0 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        background: #F8F8F8;
        border-radius: 4px;
        margin-bottom: 20px;
        img {
            width: 100px;
            height: 66px;
            margin-bottom: 0 !important;
        }
        .text {
            height: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            line-height: 20px;
        }
    }
</style>